// src/pages/About.js
import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        {/* عنوان اصلی */}
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center text-gold-dark mb-6">
          درباره گالری طلا و جواهری خرمی
        </h1>
        <p className="text-center text-lg md:text-xl text-gray-600 mb-16 max-w-3xl mx-auto">
          سنتی دیرینه، اعتماد پایدار، کیفیت بی‌چون‌وچرا
        </p>

        {/* بخش تاریخچه + عکس قدیمی */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-20">
          {/* عکس قدیمی (سمت راست در دسکتاپ، بالا در موبایل) */}
          <div className="order-2 lg:order-1 rounded-2xl overflow-hidden shadow-2xl border border-gray-200">
            <img
              src="/about-old-gallery.jpg"  // ← اینجا مسیر عکس قدیمی خودت رو بگذار
              // اگر در public گذاشتی: src="/images/old-gallery.jpg"
              // یا اگر از backend میاد: src={someUrlFromBackend}
              alt="گالری قدیمی خرمی - دهه ۱۳۵۰"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
            <p className="text-center text-sm text-gray-500 mt-3 italic">
              گالری طلا و جواهری خرمی در سال‌های آغازین فعالیت
            </p>
          </div>

          {/* متن تاریخچه */}
          <div className="order-1 lg:order-2 text-lg text-gray-700 leading-relaxed space-y-6">
            <p className="text-2xl font-bold text-gold-dark mb-8">
              درباره ما
            </p>

            <p>
              گالری طلا و جواهری خرمی با افتخار از <strong>سال ۱۳۵۰</strong> در بازار هنر، با مدیریت <strong>حاج بهرام خرمی</strong> و با برند «گالری خرم» آغاز به کار کرد. این برند قدیمی، هم‌اکنون با نام <strong>«گالری طلا و جواهری خرمی»</strong> و با مدیریت <strong>محسن خرمی</strong>، با افتخار در حال خدمت‌رسانی به مشتریان وفادار و جذب مشتریان جدید است.
            </p>

            <div className="border-r-4 border-gold pr-6 mt-10">
              <h3 className="text-xl font-bold text-gray-800 mb-4">تاریخچه گالری</h3>
              <ul className="space-y-4 text-gray-700">
                <li><strong>سال ۱۳۵۰:</strong> آغاز فعالیت با مدیریت حاج بهرام خرمی در بازار هنر.</li>
                <li><strong>دهه ۱۳۷۰:</strong> توسعه فعالیت‌ها و افزایش تنوع محصولات.</li>
                <li><strong>دهه ۱۳۸۰:</strong> ارائه طراحی‌های اختصاصی و سفارشی.</li>
                <li><strong>سال ۱۳۹۵:</strong> انتقال مدیریت به محسن خرمی و نوسازی برند.</li>
                <li><strong>سال ۱۴۰۰ به بعد:</strong> آغاز فروش آنلاین و خدمات دیجیتال.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* آمار کوتاه (اختیاری - اگر خواستی حذف کن) */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
          <div className="p-8 bg-white rounded-2xl shadow-lg border border-gold/20">
            <h3 className="text-4xl font-bold text-gold-dark mb-2">+۷۵</h3>
            <p className="text-gray-600">سال اعتبار و اعتماد</p>
          </div>
          <div className="p-8 bg-white rounded-2xl shadow-lg border border-gold/20">
            <h3 className="text-4xl font-bold text-gold-dark mb-2">هزاران</h3>
            <p className="text-gray-600">مشتری وفادار</p>
          </div>
          <div className="p-8 bg-white rounded-2xl shadow-lg border border-gold/20">
            <h3 className="text-4xl font-bold text-gold-dark mb-2">صدها</h3>
            <p className="text-gray-600">طراحی اختصاصی</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;